import React from 'react'
import LighterText from 'components/Text/Lighter'
import { Container, InputText } from './DefaultInput.style'

import Input from 'components/Inputs/Interface'

const DefaultInput = (props: Input) => {
	return (
		<Container>
			<LighterText>{props.title}</LighterText>
			<InputText {...props} />
		</Container>
	)
}

export default DefaultInput
